import React from 'react'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import NoMatch from './pages/NoMatch';
import "./App.css"
import Profiling from './pages/profiling/Profiling';
import CreateProfiling from './pages/profiling/CreateProfiling';
import EditProfiling from './pages/profiling/EditProfiling';
import ViewProfile from './pages/profiling/ViewProfile';
import Lead from './pages/leads/Lead';
import CreateLead from './pages/leads/CreateLead';
import ViewLead from './pages/leads/ViewLead';
import EditLead from './pages/leads/EditLead';
import Customer from './pages/customers/Customer';
import CreateCustomer from './pages/customers/CreateCustomer'
import EditCustomer from './pages/customers/EditCustomer';
import ViewCustomer from './pages/customers/ViewCustomer';
import Sale from './pages/sales/Sale';
import ListUser from './pages/users/ListUser';
import Localization from './pages/configurations/Localization';
import Currency from './pages/configurations/Currency';
import GeneralSettings from './pages/configurations/GeneralSettings';
import ModuleSettings from './pages/configurations/ModuleSettings';
import Tax from './pages/configurations/Tax';
import Login from './pages/auth/Login';
import Tasks from './pages/tasks/Tasks';
import CreateTask from './pages/tasks/CreateTask';
import EditTask from './pages/tasks/EditTask';
import ViewTask from './pages/tasks/ViewTask'
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './PriavateRoute';
import CreateUser from './pages/users/CreateUser';
import EditUser from './pages/users/EditUser';
import CreateRole from './pages/roles/CreateRole';
import ListRole from './pages/roles/ListRole';
import ListProduct from './pages/products/ListProduct';
import CreateProduct from './pages/products/CreateProduct';
import ListCategory from './pages/categories/ListCategory';
import CreateCategory from './pages/categories/CreateCategory';
import EditCategory from './pages/categories/EditCategory';
import EditProduct from './pages/products/EditProduct';
import ListGroup from './pages/groups/ListGroup';
import CreateGroup from './pages/groups/CreateGroup';
import EditGroup from './pages/groups/EditGroup';
import ListChecklist from './pages/checklists/ListChecklist';
import CreateChecklist from './pages/checklists/CreateChecklist';
import EditChecklist from './pages/checklists/EditChecklist';
import ListPlan from './pages/plans/ListPlan';
import CreatePlan from './pages/plans/CreatePlan';
import EditPlan from './pages/plans/EditPlan';
import VerifiedProfiling from './pages/profiling/VerifiedProfiling';
import Tickets from './pages/tickets/Tickets';
import EditTicket from './pages/tickets/EditTicket';
import ViewTicket from './pages/tickets/ViewTicket';
import Departments from './pages/configurations/Department/Departments';
import CreateDepartment from './pages/configurations/Department/CreateDepartment';
import EditDepartment from './pages/configurations/Department/EditDepartment';
import Designations from './pages/configurations/Designation/Designations';
import CreateDesignation from './pages/configurations/Designation/CreateDesignation';
import EditDesignation from './pages/configurations/Designation/EditDesignation';
import SystemLogs from './pages/configurations/SystemLogs';
import ListFeedback from './pages/feedback/ListFeedback';
import ViewFeedback from './pages/feedback/ViewFeedback';
import CreateFeedbackLink from './pages/feedback/feedback-links/CreateFeedbackLink';
import CreateFeedback from './pages/feedback/CreateFeedback';
import FeedbackSettings from './pages/feedback/feedback-settings/FeedbackSettings';
import CreateFeedbackSettings from './pages/feedback/feedback-settings/CreateFeedbackSettings';
import ListFeedbackLinks from './pages/feedback/feedback-links/ListFeedbackLinks';
import ListProposal from './pages/sales/proposal/ListProposal';
import CreateProposal from './pages/sales/proposal/CreateProposal';
import EditProposal from './pages/sales/proposal/EditProposal';
import ListInvoice from './pages/sales/invoice/ListInvoice';
import CreateInvoice from './pages/sales/invoice/CreateInvoice';
import ViewProposal from './pages/sales/proposal/ViewProposal';
import ListCreditNote from './pages/sales/credit-note/ListCreditNote';
import CreateCreditNote from './pages/sales/credit-note/CreateCreditNote';
import ViewCompany from './pages/company/ViewCompany';
import ViewUser from './pages/users/ViewUser';
import Account from './pages/account/Account';
import Enable2FactorAuth from './pages/account/Enable2FactorAuth';
import Invoices from './pages/purchase/Invoices';
import CreditNotes from './pages/purchase/CreditNotes';
import Payments from './pages/purchase/Payments';
import Orders from './pages/purchase/Orders';
import Vendors from './pages/purchase/Vendors'
import ListFieldVisit from './pages/field-visit/ListFieldVisit';
import ListRenewal from './pages/renewals/ListRenewal';
import ForgetPassword from './pages/auth/ForgetPassword';
import ResetPassword from './pages/auth/ResetPassword';
import CreateFieldVisit from './pages/field-visit/CreateFieldVisit';

function App() {

  return (
    <AuthProvider>
      <Routes>
        <Route index path="/" name="Login" element={<Login />} />
        <Route index path="/forget-password" name="Forget Password" element={<ForgetPassword />} />
        <Route index path="/reset-password" name="Reset Password" element={<ResetPassword />} />
        <Route path='feedbacks/create' name="Create Feedback" element={<CreateFeedback />} />

        <Route element={<PrivateRoute />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/profiling' element={<Profiling />} />
          <Route path='/verified-data' element={<VerifiedProfiling />} />
          <Route path='/verified-data/create' element={<CreateProfiling />} />
          <Route path='profiling/create' element={<CreateProfiling />} />
          <Route path='profiling/:id/edit' element={<EditProfiling />} />
          <Route path='profiling/:id' element={<ViewProfile />} />

          <Route path='leads' element={<Lead />} />
          <Route path='leads/create' element={<CreateLead />} />
          <Route path='leads/:id/edit' element={<EditLead />} />
          <Route path='leads/:id' element={<ViewLead />} />

          <Route path='customers' element={<Customer />} />
          <Route path='customers/create' element={<CreateCustomer />} />
          <Route path='customers/:id/edit' element={<EditCustomer />} />
          <Route path='customers/:id' element={<ViewCustomer />} />

          <Route path='user' element={<ListUser />} />
          <Route path='user/create' element={<CreateUser />} />
          <Route path='user/:id/edit' element={<EditUser />} />
          <Route path='user/:id' element={<ViewUser />} />

          <Route path='role' element={<ListRole />} />
          <Route path='role/create' element={<CreateRole />} />

          <Route path='sales' element={<Sale />} />
          <Route path='sales/create' element={<Sale />} />
          <Route path='sales/:id/edit' element={<Sale />} />

          <Route path='tasks' element={<Tasks />} />
          <Route path='tasks/create' element={<CreateTask />} />
          <Route path='tasks/:id/edit' element={<EditTask />} />
          <Route path='tasks/:id' element={<ViewTask />} />
          
          <Route path='localization' element={<Localization />} />
          <Route path='currency' element={<Currency />} />
          <Route path='general-settings' element={<GeneralSettings />} />
          <Route path='module-settings' element={<ModuleSettings />} />
          <Route path='system-logs' element={<SystemLogs/>} />
          <Route path='tax' element={<Tax/>} />

          {/* Department Routes */}
          <Route path='departments/' element={<Departments/>} />
          <Route path='departments/create' element={<CreateDepartment/>} />
          <Route path='departments/:id/edit' element={<EditDepartment/>} />

          {/* Designation Routes */}
          <Route path='designations/' element={<Designations/>} />
          <Route path='designations/create' element={<CreateDesignation/>} />
          <Route path='designations/:id/edit' element={<EditDesignation/>} />

          {/* Product Routes */}
          <Route path='products' element={<ListProduct />}/>
          <Route path='products/create' element={<CreateProduct />}/>
          <Route path='products/:id/edit' element={<EditProduct />}/>

           {/* Categories Routes */}
           <Route path='categories' element={<ListCategory />}/>
           <Route path='categories/create' element={<CreateCategory />}/>
           <Route path='categories/:id/edit' element={<EditCategory />}/>

          {/* Group Routes */}
          <Route path='groups' element={<ListGroup />} />
          <Route path='groups/create' element={<CreateGroup />} />
          <Route path='groups/:id/edit' element={<EditGroup />} />

          {/* Checklist Routes */}
          <Route path='checklists' element={<ListChecklist />} />
          <Route path='checklists/create' element={<CreateChecklist />} />
          <Route path='checklists/:id/edit' element={<EditChecklist />} />

          {/* Plan Routes */}
          <Route path='plans' element={<ListPlan />} />
          <Route path='plans/create' element={<CreatePlan />} />
          <Route path='plans/:id/edit' element={<EditPlan />} />

          {/* Tickets Routes */}
          <Route path='tickets' element={<Tickets />} />
          <Route path='tickets/:id/edit' element={<EditTicket />} />
          <Route path='tickets/:id/:service' element={<ViewTicket />} />

           {/* Feedback Routes */}
           <Route path='feedbacks' element={<ListFeedback />} />
           <Route path='feedbacks/:id/view' element={<ViewFeedback />} />

            {/* Feedback Settings Routes */}

           <Route path='feedback-settings' element={<FeedbackSettings />} />
           <Route path='feedback-settings/create' element={<CreateFeedbackSettings />} />

            {/* Feedback Link Routes */}
            <Route path='feedback-links' element={<ListFeedbackLinks />} />
           <Route path='feedback-links/create' element={<CreateFeedbackLink />} />

           {/* Proposal Routes */}
           <Route path='proposals' element={<ListProposal />} />
           <Route path='proposals/create' element={<CreateProposal />} />
           <Route path='proposals/:id/edit' element={<EditProposal />} />
           <Route path='proposals/:id/view' element={<ViewProposal />} />

            {/* Invoice Routes */}
            <Route path='invoices' element={<ListInvoice />} />
            <Route path='invoices/create' element={<CreateInvoice />} />

            {/* Credit Note Routes */}
            <Route path='credit-notes' element={<ListCreditNote />} />
            <Route path='credit-notes/create' element={<CreateCreditNote />} />

            {/* Payment Routes */}
            <Route path='payments' element={<ListInvoice />} />
            <Route path='payments/create' element={<CreateInvoice />} />

             {/* Company Routes */}
             <Route path='company/:id/view' element={<ViewCompany />} />

             {/* Account Routes */}
             <Route path='account' element={<Account />} />
             <Route path='account/authenticator' element={<Enable2FactorAuth />} />

             {/* Purchase Routes */}
             <Route path='purchase-invoices' element={<Invoices />} />
             <Route path='purchase-credit-notes' element={<CreditNotes />} />
             <Route path='purchase-orders' element={<Orders />} />
             <Route path='purchase-payments' element={<Payments />} />
             <Route path='purchase-vendors' element={<Vendors />} />


            {/* Field Visit Routes */}
              <Route path='field-visits' element={<ListFieldVisit />} />
              <Route path='field-visits/create' element={<CreateFieldVisit />} />

            {/* Renewal Routes */}
            <Route path='renewals' element={<ListRenewal />} />

        </Route>

        <Route path="*" element={<NoMatch />} />
      </Routes>
    </AuthProvider> 
  )
}

export default App;
